<template>
  <modal-brandme :show_modal="open_modal_login">
    <template #body>
      <login-container></login-container>
    </template>
  </modal-brandme>
</template>

<script>
export default {
  name: 'ModalLogin',
  components: {
    modalBrandme: () => import('@/views/components/modal/ModalBrandme.vue'),
    LoginContainer: () => import('@/views/components/login/loginContainer.vue'),
  },
  props: {
    open_modal: {
      type: Boolean,
      default: false,
    }
  },
  data() {
    return {
      open_modal_login: this.open_modal,
    }
  },
}
</script>